import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import type { ComponentPropsWithoutRef, ReactNode } from "react";

const contentClasses =
  "z-50 max-w-xs rounded-[var(--radius-3)] border border-border-1 bg-bg-2 px-2.5 py-1.5 " +
  "font-mono text-caption leading-snug text-fg-1 shadow-[var(--shadow-1)] " +
  "data-[state=delayed-open]:animate-in data-[state=closed]:animate-out " +
  "data-[state=closed]:fade-out-0 data-[state=delayed-open]:fade-in-0";

export const TooltipProvider = TooltipPrimitive.Provider;
const TooltipRoot = TooltipPrimitive.Root;
const TooltipTrigger = TooltipPrimitive.Trigger;

type TooltipContentProps = ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>;

function TooltipContent({
  className = "",
  sideOffset = 6,
  children,
  ...rest
}: TooltipContentProps) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        sideOffset={sideOffset}
        className={`${contentClasses} ${className}`.trim()}
        {...rest}
      >
        {children}
        <TooltipPrimitive.Arrow className="fill-border-1" width={10} height={5} />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  );
}

export type TooltipProps = {
  content: ReactNode;
  children: ReactNode;
  delayDuration?: number;
  side?: TooltipContentProps["side"];
  align?: TooltipContentProps["align"];
};

export function Tooltip({
  content,
  children,
  delayDuration = 150,
  side = "top",
  align = "center",
}: TooltipProps) {
  return (
    <TooltipRoot delayDuration={delayDuration}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={side} align={align}>
        {content}
      </TooltipContent>
    </TooltipRoot>
  );
}
